import { render, staticRenderFns } from "./ProfileTabs.vue?vue&type=template&id=5d5b76d6"
import script from "./ProfileTabs.vue?vue&type=script&lang=js"
export * from "./ProfileTabs.vue?vue&type=script&lang=js"
import style0 from "./ProfileTabs.vue?vue&type=style&index=0&id=5d5b76d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports